import DeleteAccountButton from "./deleteAccount"

export default DeleteAccountButton
